import { useState } from "react"
import * as voucherApi from '../api/voucher/voucherApi';
import useDebounce from "./useDebounce";
import { NO_VIEW, VoucherTypeTable } from "../services/data";
import useToast from "./useToast";

const mapFieldsToRow = (item: any) => {
    if (!item?.fields?.length) return item;
    const fieldValues: Record<string, any> = {};
    item.fields.forEach((f: any) => {
        fieldValues[f.fieldCode] = f.view === false ? NO_VIEW : f.value;
    });
    return { ...item, ...fieldValues };
};


interface IPagination {
    current: number
    total: number
    pageSize: number
}
interface IVoucherState {
    list: voucherApi.IVoucherCode[]
    pagination: IPagination
}

export interface IVoucherData {
    all: IVoucherState
    unused: IVoucherState
    used: IVoucherState
}

const defaultPagination: IPagination = {
    current: 1,
    total: 0,
    pageSize: 10,
}

export const useVoucherDetail = (id: number, voucherTypeTable: string, dataFilter: any) => {
    const pushToast = useToast();

    const [voucherTableDetailData, setVoucherTableDetailData] = useState<IVoucherData>({
        all: {
            list: [],
            pagination: defaultPagination,
        },

        unused: {
            list: [],
            pagination: defaultPagination,
        },

        used: {
            list: [],
            pagination: defaultPagination,
        },
    })


    const getVoucherList = useDebounce(async (
        pageCurent = 1,
        pageSize = 10
    ) => {
        const result = await voucherApi.getListVoucherCode(
            id,
            pageSize,
            pageCurent,
            Number(voucherTypeTable),
            dataFilter
        )

        if (result?.status) {
            const mappedData = result.data.map(mapFieldsToRow);

            switch (Number(voucherTypeTable)) {
                case VoucherTypeTable.UN_USE:
                    setVoucherTableDetailData((prev) => ({
                        ...prev,
                        unused: {
                            list: mappedData,
                            pagination: {
                                current: pageCurent,
                                total: result.total,
                                pageSize,
                            },
                        },
                    }))
                    break;
                case VoucherTypeTable.USED:
                    setVoucherTableDetailData((prev) => ({
                        ...prev,
                        used: {
                            list: mappedData,
                            pagination: {
                                current: pageCurent,
                                total: result.total,
                                pageSize,
                            },
                        },
                    }))
                    break;
                case VoucherTypeTable.ALL:
                    setVoucherTableDetailData((prev) => ({
                        ...prev,
                        all: {
                            list: mappedData,
                            pagination: {
                                current: pageCurent,
                                total: result.total,
                                pageSize,
                            },
                        },
                    }))
                    break;

                default:
                    break;
            }
        } else {
            pushToast(result?.message, "warning")
        }
    }, 1000)

    return {
        voucherTableDetailData,
        setVoucherTableDetailData,
        getVoucherList
    }
}